import Vue from 'vue';
import {
  TranslatableField,
  transl8,
  generateUserFriendlyId,
  moneyMixins,
  dateMixins,
  addressMixins,
  validatorMixins,
  formEntryMixins,
  contentMixins,
  authMixins,
  validationMixins,
  PossibleDate,
  fileMixins,
} from 'fourwaves-shared';

export const mixinMethods = {
  // Shared mixins
  ...formEntryMixins,
  ...dateMixins,
  ...addressMixins,
  ...validatorMixins,
  ...moneyMixins,
  ...contentMixins,
  ...authMixins,
  ...validationMixins,
  ...fileMixins,
  getUserFriendlyId: generateUserFriendlyId,

  // Event website mixins
  showUserFriendlyDate(date?: PossibleDate): string {
    return date ? this.$moment(new Date(date)).format('LL') : '---';
  },
  transl8(field: TranslatableField): string {
    return transl8(field, this.$i18n);
  },
  scrollToErrorsOrContainer(): void {
    this.$nextTick(() => {
      if (this.$validator && this.$validator.errors.items.length > 0) {
        const firstError = Array.from(document.querySelectorAll('.js-validation-error')).find(elm =>
          elm.textContent?.trim(),
        );
        firstError && this.$scrollTo(firstError, { offset: -400 });
      } else {
        this.$scrollTo(`.container`, {});
      }
    });
  },
};

Vue.mixin({
  methods: mixinMethods,
});
